import { actionTypesEnum } from '../enum';

export const estadoDocumentoElectronico  = (state = null, action) => {

    if (action.type === actionTypesEnum.estadoDocumentoElectronico) {
      return action.payload;
    }
  
    return state;
  };